import React, { useState, useRef } from "react";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { IYhFormRef } from "@/components/YhFormBox/Types";
import { FormBox } from "./FormBox"
import { FixedBottom } from "./FixedBottom"
import { TableBox } from "./TableBox"
import { TopButs } from "./TopButs"
export const BmsBusSaleDetails = () => {
    const { getSelectedNavState } = useNavModel();
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);
    return (
        <>
            <TopButs {...detailsInfo} />
            <FormBox  {...detailsInfo} />
            <TableBox {...detailsInfo} />
            <FixedBottom {...detailsInfo} />
        </>
    )
}